import { defineCustomElement } from '~/utility/define-custom-element';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';
import '../../common/bn-icon';

class BinEmptyDate extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (this.loading) {
      return html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>`;
    }

    if (!this.entity || !this.entity.properties) {
      return html`${this.t('legacyLit.binEmptyDate.notEnoughData')}`;
    }

    const { properties } = this.entity;
    if (properties.emptyAt) {
      return html`${this.localizedFormatDate(properties.emptyAt, { month: 'short', day: 'numeric', hour: 'numeric' })}`;
    }

    if (properties.volume && properties.volume.forecast && properties.volume.forecast.length > 0) {
      return html`${this.t('legacyLit.binEmptyDate.14PlusDays')}`;
    }

    return html`${this.t('legacyLit.binEmptyDate.notEnoughData')}`;
  }
}

defineCustomElement('bin-empty-date', BinEmptyDate);
